import { onUnmounted, readonly, ref, type Ref } from 'vue';

const FINE_POINTER_MEDIA_QUERY: string = '(hover: hover) and (pointer: fine)';

type InputCapabilities = {
  hasFinePointer: Readonly<Ref<boolean>>;
  dispose: () => void;
};

const createInputCapabilities = (): InputCapabilities => {
  const hasFinePointer = ref<boolean>(false);
  let mediaQuery: MediaQueryList | null = null;

  const update = (): void => {
    hasFinePointer.value = mediaQuery?.matches ?? false;
  };

  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    mediaQuery = window.matchMedia(FINE_POINTER_MEDIA_QUERY);
    mediaQuery.addEventListener('change', update);
    update();
  }

  const dispose = (): void => {
    mediaQuery?.removeEventListener('change', update);
    mediaQuery = null;
  };

  return { hasFinePointer: readonly(hasFinePointer), dispose };
};

const useInputCapabilities = (): InputCapabilities => {
  const capabilities = createInputCapabilities();
  onUnmounted(capabilities.dispose);

  return capabilities;
};

export { createInputCapabilities, useInputCapabilities };
